import { SectionBackground } from '@components/SectionBackground';
import { ComplexLink } from '@components/complexLink';
import type * as React from 'react';
import { useFragment } from 'react-relay';
import SectionNavigation from '../../../sectionNavigation';
import { pageSectionClassName } from '../PageSectionsStyles';
import { linkSectionFragment } from './LinkSection.relay';
import type { LinkSectionPropsType } from './types';

const LinkSection: React.FC<LinkSectionPropsType> = (props: LinkSectionPropsType) => {
  const pageSection = useFragment(linkSectionFragment, props.pageSection);

  return (
    <div className={pageSectionClassName}>
      {props.showImage && <SectionBackground anchorName={pageSection.anchorName} url={process.env.HOST + pageSection.titleImageUrl} backgroundUrl={process.env.HOST + pageSection.titleImageBackgroundUrl} />}
      <div className="section-content-wrapper">
        <div className="text-nav-wrapper">
          <div className="section-text">
            <h1 className="text-black">{pageSection.title}</h1>
            <p>{pageSection.linkSectionText}</p>
            <div className="links-wrapper">
              {pageSection.links.map((link, index) => (
                <ComplexLink key={index} complexLink={link} className="complex-link" />
              ))}
            </div>
          </div>
          <SectionNavigation sectionNavigation={props.sectionNavigation} activeIndex={props.index} />
        </div>
      </div>
    </div>
  );
};

export { LinkSection };
